import type { CitySuggestionOption } from '@/utils/dadata';

type CityRecord = {
  id: string;
  name: string;
  geoId: string;
  timezone: string;
  meta: string;
};

const byName = new Map<string, CityRecord>();
const byId = new Map<string, CityRecord>();

const normalize = (value: string): string => value.trim().toLowerCase();

function fallbackId(name: string): string {
  return `city-${normalize(name).replace(/[^a-z0-9]+/g, '-')}`;
}

export function ensureCity(option: CitySuggestionOption): CityRecord {
  const name = option.label.trim();
  const key = normalize(name);
  const existing = byName.get(key);
  if (existing) return existing;

  const record: CityRecord = {
    id: fallbackId(name),
    name,
    geoId: option.geoId ?? `legacy:${key}`,
    timezone: option.timezone ?? 'Europe/Moscow',
    meta: option.meta ?? '{}',
  };
  byName.set(key, record);
  byId.set(record.id, record);
  return record;
}

export function getCityById(id?: string | null): CityRecord | undefined {
  if (!id) return undefined;
  return byId.get(id);
}
